<div class="backGroundHeader">
    <upsc-login-header></upsc-login-header>
</div>
<div class="wrapper">
    <router-outlet></router-outlet>
</div>
<div class="footer">
    <upsc-footer></upsc-footer>
</div>